import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-servicing/constants/apiPaths';
import {
    SvcGstSetSetTransactionHistorySessionCleanupRequest,
    SvcGstSetSetTransactionHistorySessionCleanupResponse,
} from 'scbk-servicing/types/api';

/**
 *  스피드조회 > 계좌목록 Hook *
 */
export const useSvcGstSetSetTransactionHistorySessionCleanup = (
    mutationOptions?: UseRestPostMutationOptions<
        SvcGstSetSetTransactionHistorySessionCleanupRequest,
        SvcGstSetSetTransactionHistorySessionCleanupResponse
    >,
) => {
    return useRestPost<
        SvcGstSetSetTransactionHistorySessionCleanupRequest,
        SvcGstSetSetTransactionHistorySessionCleanupResponse
    >(
        {
            endpoint: APIS.services.guest.setting.setTransactionHistorySessionCleanup,
        },
        mutationOptions,
    );
};
